import { useEffect, useState } from "react";
import { api, fileUrl } from "@/lib/api";
import { toast } from "sonner";
import { Upload, Trash2 } from "lucide-react";

export default function AdminGallery() {
  const [items, setItems] = useState([]);
  const [caption, setCaption] = useState("");
  const [busy, setBusy] = useState(false);
  const load = async () => setItems((await api.get("/gallery")).data);
  useEffect(() => { load(); }, []);
  const upload = async (file) => {
    if (!file) return;
    if (!caption) return toast.error("Add caption first");
    setBusy(true);
    const fd = new FormData(); fd.append("file", file); fd.append("folder", "gallery");
    try {
      const r = await api.post("/files/upload", fd, { headers: {"Content-Type":"multipart/form-data"}});
      const isVideo = (file.type || "").startsWith("video");
      await api.post("/admin/gallery", { caption, file_id: r.data.file_id, media_type: isVideo ? "video" : "image" });
      toast.success("Added"); setCaption(""); load();
    } catch { toast.error("Failed"); }
    setBusy(false);
  };
  const del = async (id) => { await api.delete(`/admin/gallery/${id}`); load(); };
  return (
    <div>
      <div className="text-xs uppercase tracking-[0.4em] text-[#39FF14]">Media</div>
      <h1 className="font-display text-4xl mt-2">Gallery</h1>
      <div className="mt-6 p-6 bg-[#0B132B] border border-white/10 rounded flex gap-3 flex-wrap items-center">
        <input placeholder="Caption" value={caption} onChange={(e)=>setCaption(e.target.value)} className="bg-black/50 border border-white/15 px-3 py-2 text-sm flex-1 min-w-[200px]" data-testid="gallery-caption"/>
        <label className="flex items-center gap-2 border border-dashed border-white/15 px-4 py-2 cursor-pointer text-xs hover:border-[#39FF14]"><Upload size={14} className="text-[#39FF14]"/>{busy?"Uploading…":"Choose photo/video"}<input type="file" accept="image/*,video/*" className="hidden" onChange={(e)=>upload(e.target.files?.[0])}/></label>
      </div>
      <div className="mt-6 grid grid-cols-2 md:grid-cols-4 gap-3">
        {items.map((g) => (
          <div key={g.id} className="relative border border-white/10 group">
            {g.media_type === "video" ? <video src={fileUrl(g.file_id)} className="w-full aspect-square object-cover" controls/> : <img src={fileUrl(g.file_id)} alt={g.caption} className="w-full aspect-square object-cover"/>}
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent p-3 flex items-end"><div className="text-xs">{g.caption}</div></div>
            <button onClick={()=>del(g.id)} className="absolute top-2 right-2 p-1 bg-[#FF2442] text-white opacity-0 group-hover:opacity-100"><Trash2 size={14}/></button>
          </div>
        ))}
      </div>
    </div>
  );
}
